module.exports = __webpack_public_path__ + "static/media/icon_down_gray.d82de716.svg";